import React, { useMemo } from 'react';
import { Stack, Timeline } from '@mantine/core';
import VersionsByDate from '@/pages/Editor/components/VersionHistory/VersionHistoryModal/VersionsByDate.tsx';
import { AutomationVersionSimple } from '@/types/automations.ts';

type props = {
  versions: AutomationVersionSimple[];
  publishedVersion?: AutomationVersionSimple;
  latestVersion?: AutomationVersionSimple;
};

const AllVersionsTimeline = ({ versions, publishedVersion, latestVersion }: props) => {
  const versionsByDay = useMemo(() => {
    const groupedVersions: Record<string, AutomationVersionSimple[]> = {};
    versions.forEach((version) => {
      const date = new Date(version.created_at).toDateString();
      if (!groupedVersions[date]) {
        groupedVersions[date] = [];
      }
      groupedVersions[date].push(version);
    });
    return groupedVersions;
  }, [versions]);

  return (
    <Stack>
      <Timeline
        bulletSize={24}
        lineWidth={1}
        color="#ECECED"
        active={100}
        styles={{
          itemBullet: { backgroundColor: 'transparent', borderWidth: 0, boxShadow: 'none' },
        }}
      >
        {Object.entries(versionsByDay).map(([date, versions]) => (
          <VersionsByDate
            key={date}
            date={date}
            versions={versions}
            publishedVersion={publishedVersion}
            latestVersion={latestVersion}
          />
        ))}
      </Timeline>
    </Stack>
  );
};

export default AllVersionsTimeline;
